import { Trans } from 'react-i18next';
import { Link, showDialog } from '@src/components';
import i18n from '@src/i18n';
import { supportEmail } from '@src/site';

/** Shared “write to us” dialog — footer, recover, anywhere else. */
export function openSupportDialog(): void {
  const email = supportEmail();
  showDialog({
    title: i18n.t('footer.contact'),
    submit: i18n.t('dialog.ok'),
    closeLabel: i18n.t('dialog.close'),
    testId: 'support',
    children: (
      <Trans
        i18nKey="footer.contactBody"
        values={{ email }}
        components={{
          email: <Link href={`mailto:${email}`} variant="inline" />,
          faq: <Link href="/faq" variant="inline" />,
        }}
      />
    ),
  });
}
